import { render, staticRenderFns } from "./ItemTab.vue?vue&type=template&id=5b63ccd0&"
import script from "./ItemTab.vue?vue&type=script&lang=js&"
export * from "./ItemTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports